<i18n>
{
  "fr": {
    "cancel": "Annuler",
    "title-select": "Choisissez votre tarif :"
  },
  "en": {
    "cancel": "Cancel",
    "title-select": "Choose your fare:"
  }
}
</i18n>

<template>
  <v-dialog
    v-model="dialog"
    width="970px"
    scrollable
    persistent
  >
    <div>
      <v-card
        min-width="300px"
        max-width="970px"
      >
        <v-card-title class="pb-1">
          <v-col class="pa-0">
            {{ $t('title-select') }}
          </v-col>
          <v-spacer />
          <v-btn
            icon
            @click="close()"
          >
            <v-icon color="primary">
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="px-4 py-1">
          <v-row
            class="justify-center pa-0"
            justify="center"
          >
            <v-col
              v-for="pp in allOptionsNotStandardPlus()"
              :key="pp.itinerary.identifier"
              cols="4"
              class="px-2 py-2"
            >
              <FlightSelectPriceRevalidateCard
                :pp="pp"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import FlightSelectPriceRevalidateCard
  from '@/components/Flight/FlightSearchResults/FlightSearchResultsGroupPrice/FlightSelectPriceCard/FlightSelectPriceRevalidateCard'
import _ from 'lodash'

export default {
  name: 'FlightSelectPrice',
  components: { FlightSelectPriceRevalidateCard },
  props: {
    priceDetails: {
      type: Object,
      required: true
    },
    groupPrice: {
      type: Array,
      required: true
    },
    groupPriceRevalidate: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    dialog: true
  }),
  methods: {
    allOptionsNotStandardPlus () {
      // filtre des options non identique aller/retour (exemple Standard-Flex). On ne garde que les identiques aller/retour
      const opfsRes = []
      for (const i in this.groupPriceRevalidate) {
        // console.log('SJISJI this.groupPriceRevalidate[i].itinerary.price.sbt_types_segments[0].segments ', this.groupPriceRevalidate[i].itinerary.price.sbt_types_segments[0].segments)
        if (_.every(this.groupPriceRevalidate[i].itinerary.price.sbt_types_segments[0].segments, { brand_name: this.groupPriceRevalidate[i].itinerary.price.sbt_types_segments[0].segments[0].brand_name })) {
          opfsRes.push(this.groupPriceRevalidate[i])
        }
      }
      const dataToFilter = opfsRes.length > 0 ? opfsRes : this.groupPriceRevalidate
      return _.orderBy(_.filter(dataToFilter, pp => {
        return this.isNotStandardPlus(pp)
      }), [(obj) => {
        return obj.itinerary.price.total
      }], ['asc'])
    },
    isNotStandardPlus (type) {
      return _.upperCase(_.trim(type.itinerary.price.option_type)) !== 'STANDARDPLUS'
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
</style>
